import { FieldSet } from "../../utils/ui/FieldSet";
import { LeanToConfig } from "../../config/LeanToConfig";
import { Field } from "../../utils/ui/Field";
import { Templating } from "../../utils/Templating";
import { Main } from "../../Main";
import { LeanToSettingConfig } from "../../config/LeanToSettingConfig";
import { IInput } from "../../utils/ui/Input";
import { LeanToWraparoundSetting } from "../../config/LeanToWraparoundSetting";
import { LeanToWraparoundView } from "./LeanToWraparoundView";
import { LeanToSetting } from "./LeanToSetting";
import { BooleanInput } from "../../utils/ui/BooleanInput";
import {WarningWindow} from "ui/WarningWindow";
import {CustomPopupWindow} from "ui/CustomPopupWindow";

export class LeanToFieldSet extends FieldSet
{
	private _config:LeanToConfig;
	private _leanToSettings: LeanToSetting[] = [];

	private _wallField : Field;

	constructor(config:LeanToConfig, orderId:number)
	{
		super({
			label: config.label,
			fields: config.fields.array,
			orderId: orderId
		}, null);

		this._config = config;

		this._config.wall.signal.add(this.onWallChange);
		this._wallField = this.fields["wall"];
		this._wallField.input.changeSignal.add(this.onFieldChange);
				
		this.close();

		this.init();
	}

	private addInfoBubbleToWall()
	{
		const div = document.createElement("div");
		div.classList.add("infoBubbleButton");
		div.textContent = "?";
		this._wallField.element.appendChild(div);

		div.onclick = async () =>
		{
			let outerDivStyle = "width: 675px; margin-left: -150px; margin-top: -70px; margin-bottom: -60px; padding: 10px; text-align: left;";
			let imgStyle = "margin-top: 10px;";
			let imgSize = "big1";

			if (this.isInMobileMode)
			{
				outerDivStyle = "width: 400px; max-width: calc(100% + 20px); margin-left: -20px; text-align: left;";
				imgStyle = "max-width: 100%; max-height: 231px;";
				imgSize = "small";
			}
			await CustomPopupWindow.open("",
				`<div class="vbox" style="${outerDivStyle} overflow: auto; background: #515151;">
					<center><b style="font-size: 26pt;">Wall Types</b></center>
					<hr width=100% />
					If "Wall" is selected here, vertical metal panels will cover up the sides
					of your lean-to to hide the structural roof beams.
					<center>
						<img src="assets/images/leanto-wall-${imgSize}.jpg"style="${imgStyle}">
					</center>
				</div>`,
				true, "Close", null, true, "WainscotPopup");				
		};

	}

	private addInfoBubble(el: HTMLElement)
	{
		const div = document.createElement("div");
		div.classList.add("infoBubbleButton");
		div.textContent = "?";
		el.insertBefore(div, el.firstChild);

		div.onclick = async () =>
		{
			let outerDivStyle = "width: 675px; margin-left: -150px; margin-top: -70px; margin-bottom: -60px; padding: 10px; text-align: left;";
			let imgStyle = "margin-top: 10px;";
			let imgSize = "big1";

			if (this.isInMobileMode)
			{
				outerDivStyle = "width: 400px; max-width: calc(100% + 20px); margin-left: -20px; text-align: left;";
				imgStyle = "max-width: 100%; max-height: 231px;";
				imgSize = "small";
			}
			await CustomPopupWindow.open("",
				`<div class="vbox" style="${outerDivStyle} overflow: auto; background: #515151;">
					<center><b style="font-size: 26pt;">Lean-To</b></center>
					<hr width=100% />
					Also referred to as a porch roof, there are options to wrap or hip the corners together. Both the sidewall and endwall Lean-To have to be the same width and pitch to wrap.
					<center>
						<img src="assets/images/leanto-${imgSize}.jpg"style="${imgStyle}">
					</center>
				</div>`,
				true, "Close", null, true, "WainscotPopup");				
		};
	}

	private init()
	{
		const leanTos = [
			{
				"id" : "back",
				"label": "Back"
			},
			{
				"id" : "left",
				"label": "Left"
			},
			{
				"id" : "right",
				"label": "Right"
			},
			{
				"id" : "front",
				"label": "Front"
			}
		];

		const leanToSectionData = {};

		const el = Templating.renderDOMFromScript("leanToSection", leanToSectionData);

		this.addInfoBubble(el);

		const leanToConfig: LeanToConfig = Main.getInstance().config.building.leanto;

		let leanTo_i = leanTos[0];
		let leanToSettingConfig: LeanToSettingConfig = leanToConfig[leanTo_i.id];
		let leanToSetting = new LeanToSetting(leanTo_i, leanToSettingConfig);

		this._leanToSettings.push(leanToSetting);

		let hbox = document.createElement("div");
		hbox.classList.add("hbox");
		hbox.style.alignItems = "flex-end";

		hbox.appendChild(this.getWraparoundButton(0));
		hbox.appendChild(leanToSetting.element);
		hbox.appendChild(this.getWraparoundButton(1));
		el.appendChild(hbox);

		hbox = document.createElement("div");
		hbox.classList.add("hbox");
		
		leanTo_i = leanTos[1];
		leanToSettingConfig = leanToConfig[leanTo_i.id];
		leanToSetting = new LeanToSetting(leanTo_i, leanToSettingConfig);
		hbox.appendChild(leanToSetting.element);
		this._leanToSettings.push(leanToSetting);

		leanTo_i = leanTos[2];
		leanToSettingConfig = leanToConfig[leanTo_i.id];
		leanToSetting = new LeanToSetting(leanTo_i, leanToSettingConfig);
		hbox.appendChild(leanToSetting.element);
		this._leanToSettings.push(leanToSetting);

		el.appendChild(hbox);

		hbox = document.createElement("div");
		hbox.classList.add("hbox");

		leanTo_i = leanTos[3];
		leanToSettingConfig = leanToConfig[leanTo_i.id];
		leanToSetting = new LeanToSetting(leanTo_i, leanToSettingConfig);
		hbox.appendChild(this.getWraparoundButton(2));
		hbox.appendChild(leanToSetting.element);
		hbox.appendChild(this.getWraparoundButton(3));
		el.appendChild(hbox);
		this._leanToSettings.push(leanToSetting);

		this.addInfoBubbleToWall();

		el.appendChild(this._wallField.element);

		this.element.appendChild(el);

		// add nextStep to the bottom
		const nextStep = <HTMLElement>this.element.querySelector('[data-type="nextStep"]');
		this.element.appendChild(nextStep);
	}

	private onFieldChange = (value:any, input:IInput) =>
	{
		const id = input.id;

		// todo this is obsolete now with config
		// also its type unsafe
		switch (id)
		{
			case "wall":
				this._config.wall.setValue(value);
				break;

			default :
				console.log("Error! Input not handled with id:", id);
				break;
		}
	}

	private onWallChange = (value: boolean) =>
	{
		(this._wallField.input as BooleanInput).setChecked(value);
	}

	private getWraparoundButton(index: number)
	{
		const wraparounds = LeanToWraparoundSetting.CONFIGS;

		const config = wraparounds[index];

		const leanToConfig:LeanToConfig = Main.getInstance().config.building.leanto;
		const wraparound_property_name = "wraparound_" + config.vertical + "_" + config.horizontal;
		const setting = leanToConfig[wraparound_property_name];

		const wraparoundView = new LeanToWraparoundView(setting);
		
		return wraparoundView.element;
	}

	public get leanToSettings()
	{
		return this._leanToSettings;
	}

	public get wallField()
	{
		return this._wallField;
	}
	public get isInMobileMode()
	{
		return Main.getInstance().isInMobileMode;
	}
}
